import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { Alert } from 'reactstrap';
import { LOGIN_PATH } from '../../utils/constants';

export default class ConfirmRegistration extends PureComponent {
  resendMail() {
    const { email, resendActivation } = this.props;
    resendActivation(email, window.location.origin);
  }

  render() {
    const { email, success, error } = this.props;
    return (
      <div className="confirmation-description">
        {error && (
          <Alert color="danger">
            Something went wrong on resend activation email. Please try one more
            time
          </Alert>
        )}
        <div className="confirmation-title">
          A confirmation email was {success ? 're-' : ' '}
          sent to <span className="link">{email}</span>
        </div>
        <p>
          To activate your account, please click the link in the email that was
          sent to you.
        </p>
        <hr />
        <p>
          Didn’t receive the confirmation email? (Did you check the junk email
          folder?) Request a new confirmation email by{' '}
          <Link to="#" onClick={this.resendMail.bind(this)}>
            clicking here
          </Link>
        </p>
        <hr />
        <p>
          Already activated your account? <Link to={LOGIN_PATH}>Login now</Link>
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/confirm/ConfirmRegistration.js